import React from "react";
import { Link } from "react-router-dom";
import { PILLARS } from "../mock";
import { ArrowUpRight } from "lucide-react";

export default function PillarsSection() {
  return (
    <section id="pillars" className="relative bg-[var(--lc-cream)] py-20 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 lg:mb-20">
          <div className="lg:col-span-7">
            <div className="eyebrow text-[var(--lc-moss)] mb-5">The Six Pillars</div>
            <h2 className="font-serif-display text-[clamp(36px,5.5vw,76px)] leading-[1] font-light">
              Elite health is never <span className="italic">one discipline.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pt-8">
            <p className="text-[15px] leading-relaxed text-[var(--lc-muted)] max-w-md">
              Most programs focus on sweat in the gym, ignoring what actually
              slows down physical aging. We coordinate six disciplines into one
              plan tailored to your goals and schedule.
            </p>
            <Link
              to="/build"
              className="inline-flex items-center gap-2 mt-6 text-[12px] font-bold tracking-[0.18em] uppercase border-b border-[var(--lc-ink)] pb-1 hover:gap-3 transition-all"
            >
              Build Your Plan <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <article
                key={p.id}
                className="group relative overflow-hidden rounded-md bg-white border border-[var(--lc-line)] hover:shadow-2xl hover:-translate-y-1 transition-all duration-500"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                  <div className="absolute top-4 left-4 flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-white/15 backdrop-blur-md border border-white/30 grid place-items-center">
                      <Icon className="h-4 w-4 text-white" />
                    </div>
                    <span className="text-white text-[11px] tracking-[0.2em] font-semibold">
                      {p.number}
                    </span>
                  </div>
                  <div className="absolute bottom-4 left-5 text-white">
                    <div className="font-serif-display text-2xl leading-tight">{p.name}</div>
                  </div>
                </div>
                <div className="p-5 lg:p-6">
                  <p className="text-[14px] leading-relaxed text-[var(--lc-muted)]">{p.description}</p>
                  <Link
                    to={`/build?pillar=${p.id}`}
                    className="inline-flex items-center gap-1.5 mt-4 text-[11px] font-bold tracking-[0.18em] uppercase text-[var(--lc-moss)] hover:gap-2.5 transition-all"
                  >
                    Browse {p.short} services
                    <ArrowUpRight className="h-3.5 w-3.5" />
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
